import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import classnames from "classnames";
import config from "../../../../../config"; // Components

import Map from "../../../../../components/Map";
import "./Floorplate.scss";
export var Floorplate = function Floorplate(a) {
  var b = a.building,
      c = useState(0),
      d = _slicedToArray(c, 2),
      e = d[0],
      f = d[1],
      g = b.levels.slice(0).filter(function (a) {
    return a.apartments.length;
  }),
      h = g[e],
      i = [{
    coords: h.apartments,
    image: h.image,
    link: function link(a) {
      return a.slug && config.routes.get("houseandland", a.slug);
    },
    legend: [{
      label: "Available"
    }, {
      label: "Hold",
      className: "builders"
    }, {
      label: "Sold"
    }]
  }];

  return /*#__PURE__*/React.createElement("section", {
    className: "floorplates"
  }, /*#__PURE__*/React.createElement("div", {
    className: "floorplates--nav"
  }, /*#__PURE__*/React.createElement("h3", null, "Floor Plates"), /*#__PURE__*/React.createElement("ul", null, g.map(function (a, b) {
    var c = a.name,
        d = classnames({
      active: e === b
    });
    return /*#__PURE__*/React.createElement("li", {
      key: b,
      onClick: function onClick() {
        return f(b);
      },
      className: d
    }, "G" === c ? "Ground Floor" : "Level ".concat(c));
  }).reverse())), /*#__PURE__*/React.createElement("div", {
    className: "floorplates--map"
  }, /*#__PURE__*/React.createElement(Map, {
    levels: i,
    showLabel: !0,
    noButtons: !0
  })));
};
export default Floorplate;